import { render, staticRenderFns } from "./PopupImage.vue?vue&type=template&id=f12a621c"
import script from "./PopupImage.vue?vue&type=script&lang=ts"
export * from "./PopupImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports